import React from 'react';
import JokeGenerator from './component/Joke';
export default function App() {
  return (
    <JokeGenerator/>
)}

